/**
 * file : AllTournament/Tap/Index.jsx
 * 설명 : 메인 화면 -> 텝 메인 부분
 */

import Note from "./Note"
import Board from "./Board"
import Ranking from "./Ranking"
import HallOfFame from "./HallOfFame"

import { Tab } from "components/Common/Componentization"

export default function Index() {

  const titles = ['명예의 전당', '실시간 랭킹', '입상자 게시판', '공지사항'];
  const contents = [<HallOfFame />, <Ranking />, <Board />, <Note />];

  return (
    <div className="bbs_wrap">
      <Tab title={titles} content={contents} />
	  </div>
  )
}